import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import './styles/sport-progress-theme.css';
import './styles/responsive.css';
import './styles/pos-ui.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadRegionalConfig } from './utils/regionalConfig';

// Какие языки и гражданства открыты в этом регионе — запрашиваем при старте.
void loadRegionalConfig();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
